var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    className: "cls-1",
    d: "M6.63,14.22c-.25,0-.46.21-.46.46s.21.46.46.46.46-.21.46-.46h0c0-.25-.21-.46-.46-.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    className: "cls-1",
    d: "M13.65,14.22c-.25,0-.46.21-.46.46s.21.46.46.46.46-.21.46-.46h0c0-.25-.21-.46-.46-.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    className: "cls-1",
    d: "M10.36,11.44c-.25,0-.46.21-.46.46s.21.46.46.46.46-.21.46-.46h0c0-.25-.21-.46-.46-.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    className: "cls-1",
    d: "M17.37,11.44c-.25,0-.46.21-.46.46s.21.46.46.46.46-.21.46-.46h0c0-.25-.21-.46-.46-.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    className: "cls-1",
    d: "M19.82,6.06h-7.2c-.15-.02-.29-.1-.39-.23l-.62-1.11c-.32-.52-.88-.84-1.48-.86h-5.94c-1.04,0-1.88.84-1.88,1.88h0v12.5c0,1.04.84,1.88,1.88,1.88h15.63c1.04,0,1.88-.84,1.88-1.88V7.94c0-1.04-.84-1.88-1.88-1.88M18.77,13.21c-.36.37-.85.58-1.36.57-.23,0-.46-.04-.68-.13l-1.2.86v.15c.02,1.04-.8,1.91-1.85,1.93s-1.91-.8-1.93-1.85c0-.03,0-.06,0-.09,0-.09.01-.18.03-.27l-.81-.74c-.19.07-.38.11-.58.11-.23,0-.47-.04-.69-.13l-1.2.86v.15c0,1.04-.85,1.89-1.89,1.89-1.04,0-1.89-.85-1.89-1.89s.85-1.89,1.89-1.89c0,0,0,0,.01,0,.27,0,.54.07.78.18l1.09-.8c-.02-.09-.03-.18-.03-.27.02-1.04.89-1.87,1.93-1.85,1.01.02,1.82.84,1.85,1.85,0,.13-.02.27-.05.4l.71.66c.22-.09.46-.14.7-.14.28,0,.55.07.8.19l1.1-.8c-.02-.09-.03-.18-.03-.27.02-1.04.88-1.87,1.93-1.85,1.01.02,1.82.83,1.85,1.84.02.48-.16.94-.49,1.29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/Tracking.98e4aa4e687e6768eb824b7141b6a4f9.svg";
export { ForwardRef as ReactComponent };